const availableFilters = [
	{ label: 'Contact Classification', key: 'Contact_Classification_1__c', type: 'text'},
	{ label: 'Cloud', key: 'Account_Name__c', type: 'list', values: ["AWS", "MS"]},
	{ label: 'Priority', key: 'Priority__c', type: 'list', values: ["Low", "Medium", "High"]},
	{ label: 'Engagement Status', key: 'Engagement_Status__c', type: 'list', values: ["Attempted", "Contacted", "Prospect", "Abandoned" ]},
	// { label: 'Opportunity Heat', key: 'Opportunity_Heat__c', type: 'list', values: ["Standard", "Hot"]},
	{ label: '  Region', key: 'Region__c', type: 'list', values: ["EMEA", "US & Canada", "Latam", "APAC"]},
	{ label: 'Role Category', key: 'Role_Category__c', type: 'text'}
];

export default availableFilters;
